import ViewSharedUtil from "../ViewSharedUtil.js";

class ViewViewStateProcessor {
  constructor(keyName, sharedStateKey) {
    this.keyName = keyName;
    this.sharedStateKey = sharedStateKey;
    this.statesToInclude = ViewViewStateProcessor.statesToIncludeArray;
  }

  static statesToIncludeArray = [
    { name: "columns", statesToInclude: ["id", "locked", "region", "hidden", "parentId", "collapsed"] }, // additionally, this processor retains the column order
    {
      name: "store",
      statesToInclude: [
        // note: we need to persist "caseSensitive" as well otherwise not existence of this field cause bryntum to consider it as Truthy
        { name: "filters", statesToInclude: ["id", "hidden", "disabled", "operator", "property", "value", "type", "sourceField", "caseSensitive"] },
        { name: "sorters", statesToInclude: ["ascending", "complexMapping", "field", "columnOwned", "sourceField"] },
        { name: "groupers", statesToInclude: ["ascending", "complexMapping", "field", "args", "custom", "fnName", "sourceField"] },
        // "collapsedGroup"
      ],
      type: "object",
    },
    "features",
    "tickSize",
    "zoomLevel",
  ]

  processStateRetrieval(prevProcessedState, viewManager, viewType, initialDefaultState) {
    const selectedView = viewManager.renderState.selectedView;
    let selectedViewStateForType = null;
    const hasPIITS = selectedView.hasPIITS;
    if (hasPIITS) {
      selectedViewStateForType = hasPIITS[viewType] || {};
    } else if (selectedView.isDefaultView) {
      selectedViewStateForType = selectedView.viewState?.customViewState?.[viewType] || {};
    } else {
      selectedViewStateForType = selectedView.viewState?.[viewType] || {};
    }
    const processedState = {};

    this.statesToInclude.forEach((stateToInclude) => {
      if (typeof stateToInclude === "object") {
        if (selectedViewStateForType[stateToInclude.name]) {
          if (stateToInclude.type === "object") {
            processedState[stateToInclude.name] = ViewSharedUtil.getNestedObjectTypeState(selectedViewStateForType, stateToInclude)
          } else {
            processedState[stateToInclude.name] = ViewSharedUtil.mergeNestedArrayTypeStateProcess(
              selectedViewStateForType, stateToInclude, { ...initialDefaultState, [stateToInclude.name]: prevProcessedState[stateToInclude.name] }
            );
            processedState[stateToInclude.name] = ViewSharedUtil.reorderColumnPositions(processedState[stateToInclude.name], selectedViewStateForType[stateToInclude.name]);
          }
        } else {
          processedState[stateToInclude.name] = initialDefaultState[stateToInclude.name];
        }
      } else if (stateToInclude in selectedViewStateForType) {
        processedState[stateToInclude] = selectedViewStateForType[stateToInclude];
      }
    });

    return { ...prevProcessedState, ...processedState };

  }

  processStateMutation(prevProcessedState, stateToUpdate, initialDefaultState) {
    const processedState = {};
    const previousState = prevProcessedState[this.sharedStateKey];

    this.statesToInclude.forEach((stateToInclude) => {
      if (typeof stateToInclude === "object" && stateToUpdate[stateToInclude.name]) {
        if (stateToInclude.type === "object") {
          processedState[stateToInclude.name] = ViewSharedUtil.getNestedObjectTypeState(stateToUpdate, stateToInclude);
        } else {
          processedState[stateToInclude.name] = ViewSharedUtil.getNestedArrayTypeStateProcess(stateToUpdate, stateToInclude, { ...initialDefaultState, [stateToInclude.name]: previousState[stateToInclude.name] });
          processedState[stateToInclude.name] = ViewSharedUtil.reorderColumnPositions(processedState[stateToInclude.name], stateToUpdate[stateToInclude.name]);
        }
      } else if (stateToInclude in stateToUpdate) {
        processedState[stateToInclude] = stateToUpdate[stateToInclude];
      }
    });

    return { ...prevProcessedState, [this.keyName]: processedState };
  }
}

export default ViewViewStateProcessor;
